// Caja de error de carga (port de errorBox).
export function ErrorBox({ mensaje }: { mensaje: string }) {
  return (
    <div className="card">
      <div className="empty-state">
        <i className="fa-solid fa-plug-circle-xmark" style={{ color: 'var(--danger)' }} />
        <b>No se pudo conectar con el servidor</b>
        <br />
        <small>{mensaje}</small>
      </div>
    </div>
  );
}
